import AcuteHungerIndicator from './AcuteHungerIndicator';

export default AcuteHungerIndicator;
